/**
 * Bridge between the two provider catalogs. A Slack integration is created
 * through the conn catalog (provider / ingestionType `slack-webhook`), but its
 * bot token is managed as an identity credential whose provider id is `slack`.
 * These helpers map one to the other so the bot-token panel can be gated to
 * Slack integrations and resolve the right identity catalog entry.
 */

/** Identity-catalog provider id for Slack (distinct from the conn provider name). */
export const SLACK_IDENTITY_PROVIDER = 'slack';

/**
 * Whether a conn integration is a Slack integration — i.e. its bot token is
 * managed as a Slack app/space credential. The conn catalog names Slack
 * `slack-webhook` (both `provider` and `ingestionType`); match either loosely so
 * a rename to `slack` / `slack-events` still resolves.
 */
export function isSlackIntegration(integration: {
  provider?: string;
  ingestionType?: string;
}): boolean {
  const p = (integration.provider ?? integration.ingestionType ?? '').toLowerCase();
  return p === 'slack' || p.startsWith('slack-') || p.startsWith('slack_');
}
